import { useState } from 'react';
import { Button } from '@radix-ui/themes';
import { call } from 'api';
import { errorToastMessage } from 'helpers/toaster';
import type { PlayerSearchForMergeType } from 'types/player';
import SearchablePlayerForMatch from './SearchablePlayerForMatch';

export const DrawWinnerModifyBox = ({ id }: { id?: string }) => {
  const [open, setOpen] = useState(false);
  const [drawWinner, setDrawWinner] = useState<PlayerSearchForMergeType | null>(null);
  const saveFn = () => {
    //call api to save draw winner
    call(
      `draws/${id}/change-winner`,
      { method: 'PUT', body: JSON.stringify({ winner_id: drawWinner!.id }) },
      () => {
        window.location.reload();
      },
      (error) => {
        errorToastMessage(JSON.stringify(error));
      },
    );
    setOpen(false);
  };
  return open ? (
    <>
      <SearchablePlayerForMatch
        label={'Modifica Vincitore'}
        player={drawWinner!}
        onChangePlayerHandler={(player: PlayerSearchForMergeType | null) => setDrawWinner(player)}
      />
      <div className='m-5 flex flex-row justify-center'>
        <Button className='cursor-pointer' onClick={saveFn}>
          Salva
        </Button>
        <Button className='ml-5 cursor-pointer' onClick={() => setOpen(false)}>
          Annulla
        </Button>
      </div>
    </>
  ) : (
    <Button className='my-4 cursor-pointer' onClick={() => setOpen(true)}>
      Modifica Vincitore
    </Button>
  );
};
export default DrawWinnerModifyBox;
